// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/projectdata/v1/win_themes.proto (package mono.projectdata.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3 } from "@bufbuild/protobuf";
import { WinTheme, WinThemeClaimInput } from "../../datagateway/v1/win_themes_pb";
/**
 * Tenant and actor always come from the authenticated gateway principal.
 *
 * @generated from message mono.projectdata.v1.ListWinThemesRequest
 */ export class ListWinThemesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListWinThemesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListWinThemesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListWinThemesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListWinThemesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string pursuit_id = 1;
   */ _define_property(this, "pursuitId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListWinThemesRequest, "runtime", proto3);
_define_property(ListWinThemesRequest, "typeName", "mono.projectdata.v1.ListWinThemesRequest");
_define_property(ListWinThemesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "pursuit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SaveWinThemeVersionRequest
 */ export class SaveWinThemeVersionRequest extends Message {
    static fromBinary(bytes, options) {
        return new SaveWinThemeVersionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveWinThemeVersionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveWinThemeVersionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveWinThemeVersionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string pursuit_id = 1;
   */ _define_property(this, "pursuitId", ""), /**
   * Empty creates; set appends a version.
   *
   * @generated from field: string win_theme_id = 2;
   */ _define_property(this, "winThemeId", ""), /**
   * @generated from field: string customer_theme_id = 3;
   */ _define_property(this, "customerThemeId", ""), /**
   * @generated from field: string customer_theme_version_id = 4;
   */ _define_property(this, "customerThemeVersionId", ""), /**
   * @generated from field: string need_summary = 5;
   */ _define_property(this, "needSummary", ""), /**
   * @generated from field: string differentiator = 6;
   */ _define_property(this, "differentiator", ""), /**
   * @generated from field: string narrative = 7;
   */ _define_property(this, "narrative", ""), /**
   * @generated from field: repeated mono.datagateway.v1.WinThemeClaimInput claims = 8;
   */ _define_property(this, "claims", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveWinThemeVersionRequest, "runtime", proto3);
_define_property(SaveWinThemeVersionRequest, "typeName", "mono.projectdata.v1.SaveWinThemeVersionRequest");
_define_property(SaveWinThemeVersionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "pursuit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "win_theme_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "customer_theme_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "customer_theme_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "need_summary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "differentiator",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "narrative",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "claims",
            kind: "message",
            T: WinThemeClaimInput,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetWinThemeHistoryRequest
 */ export class GetWinThemeHistoryRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetWinThemeHistoryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetWinThemeHistoryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetWinThemeHistoryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetWinThemeHistoryRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string pursuit_id = 1;
   */ _define_property(this, "pursuitId", ""), /**
   * @generated from field: string win_theme_id = 2;
   */ _define_property(this, "winThemeId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetWinThemeHistoryRequest, "runtime", proto3);
_define_property(GetWinThemeHistoryRequest, "typeName", "mono.projectdata.v1.GetWinThemeHistoryRequest");
_define_property(GetWinThemeHistoryRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "pursuit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "win_theme_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListWinThemesResponse
 */ export class ListWinThemesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListWinThemesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListWinThemesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListWinThemesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListWinThemesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.WinTheme win_themes = 1;
   */ _define_property(this, "winThemes", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListWinThemesResponse, "runtime", proto3);
_define_property(ListWinThemesResponse, "typeName", "mono.projectdata.v1.ListWinThemesResponse");
_define_property(ListWinThemesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "win_themes",
            kind: "message",
            T: WinTheme,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SaveWinThemeVersionResponse
 */ export class SaveWinThemeVersionResponse extends Message {
    static fromBinary(bytes, options) {
        return new SaveWinThemeVersionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveWinThemeVersionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveWinThemeVersionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveWinThemeVersionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.WinTheme win_theme = 1;
   */ _define_property(this, "winTheme", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveWinThemeVersionResponse, "runtime", proto3);
_define_property(SaveWinThemeVersionResponse, "typeName", "mono.projectdata.v1.SaveWinThemeVersionResponse");
_define_property(SaveWinThemeVersionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "win_theme",
            kind: "message",
            T: WinTheme
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetWinThemeHistoryResponse
 */ export class GetWinThemeHistoryResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetWinThemeHistoryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetWinThemeHistoryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetWinThemeHistoryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetWinThemeHistoryResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.WinTheme win_theme = 1;
   */ _define_property(this, "winTheme", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetWinThemeHistoryResponse, "runtime", proto3);
_define_property(GetWinThemeHistoryResponse, "typeName", "mono.projectdata.v1.GetWinThemeHistoryResponse");
_define_property(GetWinThemeHistoryResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "win_theme",
            kind: "message",
            T: WinTheme
        }
    ]));
